import { render, staticRenderFns } from "./NotificationTag.vue?vue&type=template&id=7f1ca5b2&scoped=true"
import script from "./NotificationTag.vue?vue&type=script&lang=js"
export * from "./NotificationTag.vue?vue&type=script&lang=js"
import style0 from "./NotificationTag.vue?vue&type=style&index=0&id=7f1ca5b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1ca5b2",
  null
  
)

export default component.exports